import { Entry } from '../Entry'

export function Entry20231017() {
  return (
    <Entry title="Oct 17 2023 - v3.5.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15523/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
